// extracted by mini-css-extract-plugin
module.exports = {"loaderWrapper":"LoaderSuspense-module-loaderWrapper--HNNkc","logo":"LoaderSuspense-module-logo--El7s3","pulse":"LoaderSuspense-module-pulse--ML8vK"};